import script from "./ManagerDashboard.vue?vue&type=script&setup=true&lang=js"
export * from "./ManagerDashboard.vue?vue&type=script&setup=true&lang=js"

import "./ManagerDashboard.vue?vue&type=style&index=0&id=7519cba8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7519cba8"]])

export default __exports__